const enum InternalDashboardPages {
  POSITIONS,
  POSITION,
  CANDIDATES,
  COMPANIES,
  EMPLOYEES,
  EMPLOYERS,
  NOTES,
  COMPANY,
  JOBINTERVIEW,
  SEARCH_CANDIDATES,
  SMART_INTERVIEWS,
}

export default InternalDashboardPages;
